import Accordion from "@/components/Accordion";
import React, { useMemo } from "react";
import { LanguageConfigModel } from "@/pages/Messaging/types";

interface Props {
  onExpanded(): void;
  workingConfig: LanguageConfigModel;
  update: (updates: Partial<LanguageConfigModel>) => void;
  persist: () => void;
  loading: boolean;
}

export default function SMSForm(props: Props) {
  const saveButtonText = useMemo(() => {
    return props.loading ? "Saving..." : "Save and set live";
  }, [props.loading]);

  return (
    <Accordion.Item
      eventKey="smsOpen"
      onExpanded={() => {
        props.onExpanded();
      }}
      onCollapsed={() => {}}
    >
      <Accordion.Header>
        <Accordion.Title>SMS Channel</Accordion.Title>
        <Accordion.SubTitle>
          Customize how your visitors will start an SMS conversation
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            props.persist();
          }}
        >
          <div className="mb-4">
            <label className="block mb-2" htmlFor="sms-title">
              SMS Title
            </label>
            <input
              className="input"
              type="text"
              id="sms-title"
              value={props.workingConfig.smsTitle}
              onChange={(e) => props.update({ smsTitle: e.target.value })}
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2" htmlFor="sms-subtitle">
              SMS Subtitle
            </label>
            <input
              className="input"
              type="text"
              id="sms-subtitle"
              value={props.workingConfig.smsSubTitle}
              onChange={(e) => props.update({ smsSubTitle: e.target.value })}
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2" htmlFor="sms-message">
              Response Time Message
            </label>
            <input
              className="input"
              type="text"
              id="sms-message"
              value={props.workingConfig.smsResponseTime}
              onChange={(e) =>
                props.update({ smsResponseTime: e.target.value })
              }
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2" htmlFor="sms-header">
              Form Header
            </label>
            <input
              className="input"
              type="text"
              id="sms-header"
              value={props.workingConfig.smsFormHeader}
              onChange={(e) => props.update({ smsFormHeader: e.target.value })}
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2" htmlFor="sms-footer">
              Form Footer
            </label>
            <input
              className="input"
              type="text"
              id="sms-footer"
              value={props.workingConfig.smsFormFooter}
              onChange={(e) => props.update({ smsFormFooter: e.target.value })}
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2" htmlFor="sms-button">
              Button Text
            </label>
            <input
              className="input"
              type="text"
              id="sms-button"
              value={props.workingConfig.smsButton}
              onChange={(e) => props.update({ smsButton: e.target.value })}
            />
          </div>
          <div>
            <button className="btn-green" disabled={props.loading}>
              {saveButtonText}
            </button>
          </div>
        </form>
      </Accordion.Body>
    </Accordion.Item>
  );
}
